module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Bajo Electrico.fe4bf8d8.png";